export const transformYouTubeWatchUrl = (videoUrl: string): string | null => {
  if (!videoUrl.includes('youtube.com/watch')) return null;

  const videoId = videoUrl.split('v=')[1]?.split('&')[0];
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

export const transformYouTubeShortUrl = (videoUrl: string): string | null => {
  if (!videoUrl.includes('youtu.be/')) return null;

  const videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

export const transformVimeoUrl = (videoUrl: string): string | null => {
  if (!videoUrl.includes('vimeo.com/') || videoUrl.includes('/player.js') || videoUrl.includes('/embed/')) {
    return null;
  }

  const videoId = videoUrl.split('vimeo.com/')[1]?.split('?')[0];
  return videoId && !isNaN(Number(videoId)) ? `https://player.vimeo.com/video/${videoId}` : null;
};

export const getEmbedUrl = (videoUrl: string): string => {
  const youtubeWatch = transformYouTubeWatchUrl(videoUrl);
  if (youtubeWatch) return youtubeWatch;

  const youtubeShort = transformYouTubeShortUrl(videoUrl);
  if (youtubeShort) return youtubeShort;

  const vimeo = transformVimeoUrl(videoUrl);
  if (vimeo) return vimeo;

  return videoUrl;
};
